
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M44.338 17.885h-1.2V12.09c0-.036-.006-.072-.011-.11a.961.961 0 00-.233-.634L33.254.335l-.008-.007a.952.952 0 00-.26-.202 1.023 1.023 0 00-.193-.081l-.052-.017A.985.985 0 0032.516 0H8.824C7.742 0 6.863.88 6.863 1.96v15.924h-1.2a2.802 2.802 0 00-2.803 2.803V35.26a2.803 2.803 0 002.802 2.803h1.2v9.976c0 1.081.88 1.961 1.962 1.961h32.353c1.08 0 1.96-.88 1.96-1.96v-9.977h1.2a2.803 2.803 0 002.803-2.802V20.687a2.802 2.802 0 00-2.802-2.802zM8.824 1.96h22.711v10.031c0 .542.44.98.98.98h8.662v4.913H8.824V1.96zm14.76 26.599c-2.433-.848-4.018-2.194-4.018-4.322 0-2.499 2.085-4.41 5.538-4.41 1.652 0 2.868.347 3.736.739l-.738 2.672a6.943 6.943 0 00-3.063-.696c-1.433 0-2.128.652-2.128 1.412 0 .934.825 1.347 2.716 2.064 2.584.955 3.8 2.301 3.8 4.365 0 2.454-1.889 4.54-5.908 4.54-1.672 0-3.324-.435-4.149-.89l.673-2.738c.891.457 2.26.913 3.672.913 1.52 0 2.324-.63 2.324-1.587 0-.913-.696-1.433-2.455-2.062zm-17.248-.957c0-4.995 3.563-7.776 7.993-7.776 1.716 0 3.02.348 3.607.652l-.675 2.628a7.173 7.173 0 00-2.78-.541c-2.629 0-4.67 1.584-4.67 4.842 0 2.932 1.738 4.778 4.693 4.778.998 0 2.106-.217 2.757-.477l.5 2.585c-.608.304-1.976.63-3.757.63-5.062 0-7.668-3.15-7.668-7.32zm34.84 19.905H8.825v-9.445h32.353v9.445zm-2.19-12.802H35.12l-4.692-14.64h3.628l1.781 6.192c.5 1.737.956 3.41 1.304 5.234h.065c.369-1.76.825-3.497 1.324-5.17l1.869-6.255h3.52l-4.932 14.64z","fill":"#fff"}})])
          )
        }
      }
    